var _rect, _line, _rect2, _g, _g2, _rect3, _g3, _rect4, _g4, _rect5, _rect6, _ellipse, _g5, _ellipse2, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchitectural(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "skyGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3D2B89",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#190A4E",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    fill: "url(#skyGrad)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 500,
    x2: 800,
    y2: 500,
    stroke: "#00D9FF",
    strokeWidth: 1,
    opacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 150,
    width: 200,
    height: 350,
    fill: "#2D1B69",
    stroke: "#00D9FF",
    strokeWidth: 2,
    opacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#00D9FF",
    strokeWidth: 1,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 150,
    x2: 340,
    y2: 500
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 150,
    x2: 380,
    y2: 500
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 150,
    x2: 420,
    y2: 500
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 150,
    x2: 460,
    y2: 500
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 200,
    x2: 500,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 250,
    x2: 500,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 300,
    x2: 500,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 350,
    x2: 500,
    y2: 350
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 400,
    x2: 500,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 450,
    x2: 500,
    y2: 450
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFB02E",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 160,
    width: 20,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 210,
    width: 20,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 160,
    width: 20,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 260,
    width: 20,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 210,
    width: 20,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 310,
    width: 20,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 360,
    width: 20,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 410,
    width: 20,
    height: 30
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 300,
    width: 120,
    height: 200,
    fill: "#2D1B69",
    stroke: "#00D9FF",
    strokeWidth: 1.5,
    opacity: 0.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#00D9FF",
    strokeWidth: 0.5,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 300,
    x2: 180,
    y2: 500
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 300,
    x2: 210,
    y2: 500
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 300,
    x2: 240,
    y2: 500
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 350,
    x2: 270,
    y2: 350
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 400,
    x2: 270,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 450,
    x2: 270,
    y2: 450
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 250,
    width: 140,
    height: 250,
    fill: "#2D1B69",
    stroke: "#00D9FF",
    strokeWidth: 1.5,
    opacity: 0.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#00D9FF",
    strokeWidth: 0.5,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 565,
    y1: 250,
    x2: 565,
    y2: 500
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 250,
    x2: 600,
    y2: 500
  }), /*#__PURE__*/React.createElement("line", {
    x1: 635,
    y1: 250,
    x2: 635,
    y2: 500
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530,
    y1: 300,
    x2: 670,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530,
    y1: 350,
    x2: 670,
    y2: 350
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530,
    y1: 400,
    x2: 670,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530,
    y1: 450,
    x2: 670,
    y2: 450
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 450,
    width: 80,
    height: 50,
    fill: "#190A4E",
    stroke: "#FFB02E",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 500,
    width: 800,
    height: 100,
    fill: "#190A4E",
    opacity: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 520,
    rx: 180,
    ry: 20,
    fill: "#00D9FF",
    opacity: 0.15
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFB02E",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 530,
    x2: 500,
    y2: 530
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 525,
    x2: 300,
    y2: 535
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 525,
    x2: 500,
    y2: 535
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 80,
    rx: 50,
    ry: 25,
    fill: "#FFFFFF",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 650,
    cy: 100,
    rx: 60,
    ry: 30,
    fill: "#FFFFFF",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitectural);
export default __webpack_public_path__ + "static/media/architectural.9422aebf559ce080b995fc26dd1857a9.svg";
export { ForwardRef as ReactComponent };